import { Service, signal } from '@angular/core';
import { GridCell } from '@angular/aria/grid';

/** Which cells of one table hold a `mibCellWidget` control, provided by the table for its cells. */
@Service({ autoProvided: false })
export class MibTableWidgetsService {
  private readonly counts = signal<ReadonlyMap<GridCell, number>>(new Map());

  /** Records one more control in the cell. */
  add(cell: GridCell): void {
    this.counts.update((counts) => new Map(counts).set(cell, (counts.get(cell) ?? 0) + 1));
  }

  /** Records one control fewer in the cell. */
  remove(cell: GridCell): void {
    this.counts.update((counts) => {
      const next = new Map(counts);
      const count = (next.get(cell) ?? 0) - 1;
      if (count > 0) next.set(cell, count);
      else next.delete(cell);
      return next;
    });
  }

  /** Whether the cell holds at least one control. */
  holds(cell: GridCell): boolean {
    return this.counts().has(cell);
  }
}
